import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { GamblingSafetyLink, GamblingSafetyTopBarWrapper } from './GamblingSafetyTopBar.style';
import { LogoTakeTimeToThink } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoTakeTimeToThink';
import { GambleAwareLogo } from 'src/domains/layouts/shared/assets/iconography/logos/responsible-gambling/GambleAwareLogo';
import { LogoGamblingHelpline } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoGamblingHelpline';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const GamblingSafetyTopBar = observer('GamblingSafetyTopBar', () => {
    const common = useCommon();
    const {
        footerSaferGamblingLogos: { takeTimeToThink },
    } = ConfigComponents.get(common).config;
    return (
        <GamblingSafetyTopBarWrapper>
            <GamblingSafetyLink
                href='https://www.gambleaware.org/'
                target='_blank'
                title='GambleAware'
            >
                <GambleAwareLogo />
            </GamblingSafetyLink>

            <GamblingSafetyLink
                href='https://www.gamcare.org.uk/get-support/talk-to-us-now/'
                target='_blank'
                title='GamCare'
            >
                <LogoGamblingHelpline />
            </GamblingSafetyLink>
            {takeTimeToThink === true ? (
                <GamblingSafetyLink
                    href='http://taketimetothink.co.uk/'
                    target='_blank'
                    title='Take time to think'
                >
                    <LogoTakeTimeToThink />
                </GamblingSafetyLink>
            ) : null}
        </GamblingSafetyTopBarWrapper>
    );
});
